import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree} from '@angular/router';
import {map, Observable, of} from 'rxjs';
import {Store} from '@ngrx/store';
import {catchError, take} from 'rxjs/operators';
import {getCurrentUserRecord} from '../store/users/selectors/current-user.selectors';
import {User} from '../models/user.interface';

function isAllowedRole(roles: number[]): Observable<boolean> {
  const store: Store = inject<Store>(Store);

  return store.select(getCurrentUserRecord)
    .pipe(
      map((user: User): boolean => {
        const roleValue: number = user.role.value;
        return roles.includes(roleValue);
      }),
      take(1)
    );
}

export const requiredRolesGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const router: Router = inject(Router);

  const allowedRoles: number[] = route.data['access'] as number[];
  const mainPage: UrlTree = router.parseUrl('/');

  return isAllowedRole(allowedRoles)
    .pipe(
      map((isAllowed: boolean): boolean | UrlTree => {
        if (isAllowed) {
          return true;
        } else {
          return mainPage;
        }
      }),
      catchError((): Observable<UrlTree> => {
        return of(mainPage);
      })
    );
};
